import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "weeklyCalendarContent" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "clear"
}
const _hoisted_5 = {
  key: 1,
  class: "w100 mc rad5 ofh with_shadow_small",
  style: {"max-width":"520px"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  style: {},
  class: "fs11 grey mt4 ml4 fl"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "fs16 mt4 fw600" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "fs14 arial" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "dli_circle skyblue" }, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "dli_close pink" }, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { class: "mt10" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fl mt1 mb1" }, [
  /*#__PURE__*/_createTextVNode("午前"),
  /*#__PURE__*/_createElementVNode("span", { class: "arial" }, "(9-12)")
], -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fl mt1 mb1" }, [
  /*#__PURE__*/_createTextVNode("午後①"),
  /*#__PURE__*/_createElementVNode("span", { class: "arial" }, "(12-17)")
], -1)
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fl mt1 mb1" }, [
  /*#__PURE__*/_createTextVNode("午後②"),
  /*#__PURE__*/_createElementVNode("span", { class: "arial" }, "(17-21)")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = { class: "mt10 mb10" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = {
  key: 3,
  class: "CandidatesContent SelectModalPds mt10"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimezoneSelectContent = _resolveComponent("TimezoneSelectContent")!
  const _component_PossibleDateLi = _resolveComponent("PossibleDateLi")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isSP ? `fr mb20` : ``),
        style: _normalizeStyle({
                    width: _ctx.isSP ? `80px` : ``,
                })
      }, [
        (_ctx.showPrevButton())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`nArrow pointer fl z1 ${_ctx.isSP ? `` : `mt40 ml40`} with_shadow_small pad4 rad5 hoverLgreyBg`),
              style: {"padding":"5px 8px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevWeek && _ctx.prevWeek(...args)))
            }, [
              _createElementVNode("img", {
                id: "prevArrow",
                src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                style: {"width":"12px"}
              }, null, 8, _hoisted_2)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`nArrow pointer fl z1 ${_ctx.isSP ? `` : `mt40 ml40`} `),
              style: {"width":"18px"}
            }, " ", 2)),
        (_ctx.showNextButton())
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(`nArrow pointer fr z1 ${_ctx.isSP ? `mr10` : `mt40 mr40`} with_shadow_small  rad5 hoverLgreyBg`),
              style: {"padding":"5px 8px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextWeek && _ctx.nextWeek(...args)))
            }, [
              _createElementVNode("img", {
                id: "nextArrow",
                src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_right.png`),
                style: {"width":"12px"}
              }, null, 8, _hoisted_3)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(`nArrow pointer fr z1 ${_ctx.isSP ? `mr10` : `mt40 mr40`} `),
              style: {"width":"18px"}
            }, " ", 2))
      ], 6),
      (_ctx.isSP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.startOfWeek)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekArray, (weekDay, weekindex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w14 fl centered",
                key: `${weekindex}${_ctx.possibleDatekeys}`
              }, [
                _createElementVNode("div", {
                  style: {"height":"32px"},
                  class: _normalizeClass(`pad8 weekHeader pointer fs13 ${
                            weekindex == 0 ? `sunHeader` : weekindex == 6 ? `satHeader` : ``
                        } ${_ctx.holidays?.includes(_ctx.startOfWeek.plus({ day: weekindex })?.toFormat(`yyyyMMdd`)) ? `holiday` : ``}`)
                }, _toDisplayString(weekDay), 3),
                _createElementVNode("div", {
                  style: {"height":"60px"},
                  class: _normalizeClass(`posRe ${
                            _ctx.possibleDatekeys?.includes(_ctx.startOfWeek.plus({ day: weekindex })?.toFormat(`yyyyMMdd`))
                                ? `hasDays`
                                : `notHasDays`
                        } ${_ctx.startOfWeek.plus({ day: weekindex }).toISODate() == _ctx.selectedDate ? `selected` : ``} ${
                            _ctx.isSP ? `sp` : ``
                        }`),
                  onClick: ($event: any) => (_ctx.selectDate(_ctx.startOfWeek.plus({ day: weekindex })))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`posAb rad8 ${_ctx.selectedCheck(weekindex)}`),
                    style: {"width":"18px","height":"6px","left":"calc(50% - 9px)","top":"10px"}
                  }, "   ", 2),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.startOfWeek.plus({ day: weekindex }).month) + "/", 1),
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.startOfWeek.plus({ day: weekindex }).day), 1)
                ], 10, _hoisted_6)
              ]))
            }), 128)),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      _hoisted_11,
      (_ctx.pdm.currentCalendarDate)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "ddgrey centered fw600 mt20",
            id: `${_ctx.idprefix}dateheader`
          }, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.titleDate()) + " ", 1),
              (_ctx.idprefix == `top`)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.pdm?.room?.room_setting?.select_time_text || _ctx.$t(`message.select_time`)), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.idprefix == `sel`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", {
                      class: "label skyblueBorder fs11 pointer mr3",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.allDaySelect && _ctx.allDaySelect(...args)))
                    }, _hoisted_18),
                    _createElementVNode("label", {
                      class: "label pinkBorder fs11 pointer",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.allDayDeselect && _ctx.allDayDeselect(...args)))
                    }, _hoisted_21)
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: "circle_button blueAround fs11 pointer padw10 fl mr10 rad8 mb5",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectMorning && _ctx.selectMorning(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/icon_sun.png`),
                        width: "16",
                        height: "16",
                        class: "mr5 fl"
                      }, null, 8, _hoisted_24),
                      _hoisted_25
                    ]),
                    _createElementVNode("div", {
                      class: "circle_button blueAround fs11 pointer padw10 fl mr10 rad8 mb5",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectAfternoon && _ctx.selectAfternoon(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/icon_sun.png`),
                        width: "16",
                        height: "16",
                        class: "mr5 fl"
                      }, null, 8, _hoisted_26),
                      _hoisted_27
                    ]),
                    _createElementVNode("div", {
                      class: "circle_button blueAround fs11 pointer mr3 padw10 fl mr10 rad8 mb5",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectEvening && _ctx.selectEvening(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/icon_moon.png`),
                        width: "13",
                        height: "13",
                        class: "mr5 fl mt1"
                      }, null, 8, _hoisted_28),
                      _hoisted_29
                    ])
                  ]),
                  _hoisted_30
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_12))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_31, [
          (_ctx.showChangeTimezone())
            ? (_openBlock(), _createBlock(_component_TimezoneSelectContent, {
                key: 0,
                onSelectTimezone: _ctx.selectTimezone
              }, null, 8, ["onSelectTimezone"]))
            : _createCommentVNode("", true),
          _hoisted_32
        ])
      ]),
      (_ctx.pds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pds, (pd, pdindex) => {
              return (_openBlock(), _createBlock(_component_PossibleDateLi, {
                key: `${pd.jpFormat}${pd.selected}${pdindex}${_ctx.pds.length}${pd.tz_format}${_ctx.systemUpdatedAt}`,
                showConfirmButton: _ctx.showConfirmButton,
                useSelectbox: _ctx.useSelectbox,
                pd: pd,
                idprefix: _ctx.idprefix,
                listStyle: `flat`,
                onConfirmFixSchedule: ($event: any) => (_ctx.confirmFixSchedule(pd)),
                onClickCell: _ctx.clickPossibleDateCell,
                onRemoveDate: _ctx.removeDate
              }, null, 8, ["showConfirmButton", "useSelectbox", "pd", "idprefix", "onConfirmFixSchedule", "onClickCell", "onRemoveDate"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_34
    ]),
    _hoisted_35
  ]))
}